import script from "./CategoryGraphics.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryGraphics.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__